import React, { memo, PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Avatar } from 'antd';

import { makeSelectUserList } from '@/global.selectors';

class UserInfo extends PureComponent {
  renderName = user => user.name;
  renderAvatar = user => (<Avatar src={user.avatar} />);
  renderBoth = user => (<Fragment>
    <Avatar src={user.avatar} />
    <span style={{ marginLeft: 10 }}>{user.name}</span>
  </Fragment>)
  render() {
    const { userId, userList, className, mode, fieldName } = this.props;
    const user = userList.find(x => x[fieldName] === userId);
    if (!user) { return null; }
    const renderFn = {
      both: this.renderBoth,
      name: this.renderName,
      avatar: this.renderAvatar
    }
    return <div className={className}>{renderFn[mode](user)}</div>
  }
}

UserInfo.propTypes = {
  userId: PropTypes.number,
  className: PropTypes.string,
  mode: PropTypes.string,
  fieldName: PropTypes.string,
};

UserInfo.defaultProps = {
  userId: 0,
  className: '',
  mode: 'both',
  fieldName: 'id',
};

const mapStateToProps = createStructuredSelector({
  userList: makeSelectUserList(),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect, memo)(UserInfo);
